import type { MyAssignmentItem } from '../services/assignmentService';

type AttemptFields = Pick<MyAssignmentItem, 'rules' | 'attempts' | 'attempts_left'>;

/**
 * Attempts left on a class assignment: the most left on any of its activities, so the
 * assignment stays open while some activity can still be tried. Null when attempts are
 * unlimited (or for an adult-training assignment).
 */
export function attemptsLeft(item: AttemptFields): number | null {
  if (!item.rules?.max_attempts) return null;
  const perActivity = (item.attempts ?? []).map(a => a.left).filter((left): left is number => left !== null);
  if (perActivity.length) return Math.max(...perActivity);
  return item.attempts_left ?? item.rules.max_attempts;
}

/** Every activity has used its attempts, so the server would refuse any start. */
export function isOutOfAttempts(item: AttemptFields): boolean {
  return attemptsLeft(item) === 0;
}
